// Aviso curto no rodapé da tela, para qualquer tela (inclusive por cima da mesa): some sozinho em 3 s.
import { useSyncExternalStore } from 'react';
import { createPortal } from 'react-dom';

let atual: { id: number; texto: string } | null = null;
let contador = 0;
const ouvintes = new Set<() => void>();
const avisar = () => { for (const f of ouvintes) f(); };

export function avisarNaTela(texto: string, ms = 3000): void {
  const id = ++contador;
  atual = { id, texto };
  avisar();
  setTimeout(() => { if (atual?.id === id) { atual = null; avisar(); } }, ms);
}

export function AvisoGlobal() {
  const a = useSyncExternalStore((f) => { ouvintes.add(f); return () => ouvintes.delete(f); }, () => atual);
  if (!a || typeof document === 'undefined') return null;
  return createPortal(<p key={a.id} className="aviso-global" role="status">{a.texto}</p>, document.body);
}
